import React from 'react';
import WidgetBox from './WidgetBox';

const WidgetList = props =>
  props.widgetList.map(({ name, title, type, link, url }, i) => (
    <WidgetBox
      key={type}
      id={i}
      name={name}
      title={title}
      type={type}
      link={link}
      url={url}
      {...props}
      index={i}
    />
  ));

export default WidgetList;
